<div style="width:100%">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <icon-chart [headerConfig]="item?.config?.widget_header_config" [iconList]="iconList" [data]="data" [pageKey]="pageKey"
              [chartName]="divId" [config]="scatterPlotContainer" [fullscreen]="isFullscreen" [expand]="fs" [apiKey]="999999"
              [item]="item"
              (preferenceEmitter)="applyChartPreferences($event)"
              (changeDisplays)="changeDisplayType($event)"
              [scatterPlotRef]="this">
      </icon-chart>
      <div>
        <loading *ngIf="isLoading"> </loading>
      </div>

      <!-- legend -->
      <div id="scatterLegendDiv"
        style="width: 100%; height: 35px;display: flex; justify-content: space-between; padding: 0 5px;">
        <div id="chartToggles" style="display:flex; padding-left: 5px; align-items: center;">
          <div class="mt-1" style="text-align: left !important;">
            <!-- <div style="display:flex; align-items:center; gap: 5px;">
              <span class="headS">Expand</span>
              <mat-slide-toggle class="togControl" [checked]="useForce" (change)="toggleForce()"
                style="float: right;"></mat-slide-toggle>
            </div> -->
          </div>
          <div class="mt-1" style="text-align: left !important; margin-left: 5px;">
            <!-- <div style="display:flex; align-items:center; gap: 5px;">
              <span class="headS">Labels</span>
              <mat-slide-toggle class="togControl" [checked]="showLabels" (change)="toggleLabels()"
                style="float: right;"></mat-slide-toggle>
            </div> -->
          </div>
        </div>
      </div>

      <!-- small tooltip for legends -->
      <div id="legendToolTip"
        style="font-size: 10px; height: 15px; position: absolute; display: none; align-items: center; background: #343435; color:white; border: 1px solid #ccc; padding: 2px 20px 2px 4px; pointer-events: none;z-index: 2;">
      </div>
      <!-- chart container -->
      <div #scatterPlotContainer style="z-index: 1;" [style.display]="noData?'none':''" class="scrollcss"
        [ngStyle]="{ 'height':type=='chart'? '300px': 'auto' ,'overflow-y': 'auto' ,'margin': '0px 10px' }"></div>
      <div style="height: 300px; width: auto; " *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this Time Period' }}</span>
      </div>
      <button title="Zoom in" class="zoom-in">+</button>
      <button title="Zoom out" class="zoom-out">-</button>
      <button title="Send to Heatmap" class="heatmapIconBtn">
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_31331_5324)">
            <rect x="0" y="0" width="28" height="28" rx="14" fill="#1363DF" />
          </g>
          <rect x="6.5" y="6.5" width="6" height="6" rx="1.5" fill="white" />
          <rect x="6.5" y="15.5" width="6" height="6" rx="1.5" fill="white" />
          <rect x="15.5" y="6.5" width="6" height="6" rx="1.5" fill="white" />
          <rect x="15.5" y="15.5" width="6" height="6" rx="1.5" fill="white" />
        </svg>

      </button>
      <button title="Compare in Control Chart" class="compareIconBtn">
        <svg class="compareIcon" width="28" height="28" viewBox="0 0 28 28" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="0" width="28" height="28" rx="14" fill="#1363DF" />
          <path
            d="M8.16663 15.9167V15.8291C8.16663 15.6444 8.16663 15.5521 8.18075 15.4622C8.19328 15.3823 8.21409 15.304 8.24282 15.2285C8.27518 15.1434 8.32098 15.0632 8.41257 14.9029L10.5 11.25M8.16663 15.9167C8.16663 17.2053 9.21129 18.25 10.5 18.25C11.7886 18.25 12.8333 17.2053 12.8333 15.9167M8.16663 15.9167V15.8C8.16663 15.6367 8.16663 15.555 8.19842 15.4926C8.22638 15.4377 8.271 15.3931 8.32588 15.3651C8.38827 15.3333 8.46994 15.3333 8.63329 15.3333H12.3666C12.53 15.3333 12.6116 15.3333 12.674 15.3651C12.7289 15.3931 12.7735 15.4377 12.8015 15.4926C12.8333 15.555 12.8333 15.6367 12.8333 15.8V15.9167M10.5 11.25L12.5873 14.9029C12.6789 15.0632 12.7247 15.1434 12.7571 15.2285C12.7858 15.304 12.8066 15.3823 12.8192 15.4622C12.8333 15.5521 12.8333 15.6444 12.8333 15.8291V15.9167M10.5 11.25L17.5 10.0833M15.1666 14.75V14.6624C15.1666 14.4778 15.1666 14.3855 15.1807 14.2955C15.1933 14.2157 15.2141 14.1373 15.2428 14.0618C15.2752 13.9767 15.321 13.8966 15.4126 13.7363L17.5 10.0833M15.1666 14.75C15.1666 16.0387 16.2113 17.0833 17.5 17.0833C18.7886 17.0833 19.8333 16.0387 19.8333 14.75M15.1666 14.75V14.6333C15.1666 14.47 15.1666 14.3883 15.1984 14.3259C15.2264 14.271 15.271 14.2264 15.3259 14.1985C15.3883 14.1667 15.4699 14.1667 15.6333 14.1667H19.3666C19.53 14.1667 19.6116 14.1667 19.674 14.1985C19.7289 14.2264 19.7735 14.271 19.8015 14.3259C19.8333 14.3883 19.8333 14.47 19.8333 14.6333V14.75M17.5 10.0833L19.5873 13.7363C19.6789 13.8966 19.7247 13.9767 19.7571 14.0618C19.7858 14.1373 19.8066 14.2157 19.8192 14.2955C19.8333 14.3855 19.8333 14.4778 19.8333 14.6624V14.75M14 7.75V10.6667"
            stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <div id="d3WordCloudTooltip">
        <div class="container chart_tooltip" style="min-height: 50px; height: auto;" *ngIf="tooltip">
          <div class="row chart_tooltip_header">
            <div class="col-12 d-flex flex-column">
              <div class="chart_tooltip_header_heading mt-1 mb-1">
                {{mytooltipData.source_nm}}
              </div>
            </div>
          </div>

          <div class="mt-1 mb-5 pb-1" *ngIf="tooltipHeight >= 200"
            [ngClass]="(tooltipTurn < 250) ? 'chart_tooltip_body-after' :'chart_tooltip_body'">
            <div class="d-flex m-auto align-items-center pl-0">
              <div class="chart_tooltip_body_data ml-2">
                <div>
                  <p class="mb-0">KPI</p>
                  <p class="tooltipValue">{{mytooltipData.kpi_name}}</p>
                </div>
                <div>
                  <p class="mb-0">Date</p>
                  <p class="tooltipValue">{{mytooltipData.current_date | date:'MM.dd.yyyy'}}</p>
                </div>
                <div>
                  <p class="mb-0">KPI Value</p>
                  <p class="tooltipValue">{{mytooltipData.kpi_value}}</p>
                </div>
                <div>
                  <p class="mb-0">Control Limits</p>
                  <p class="tooltipValue">{{mytooltipData.lower_control_limit.toFixed(2)}} -
                    {{mytooltipData.upper_control_limit.toFixed(2)}}</p>
                </div>
                <div *ngIf="mytooltipData?.lower_threshold != null && mytooltipData?.upper_threshold != null">
                  <p class="mb-0">Threshold</p>
                  <p class="tooltipValue">{{mytooltipData?.lower_threshold}} - {{mytooltipData?.upper_threshold}}</p>
                </div>
                <div *ngIf="mytooltipData?.location">
                  <p class="mb-0">Location</p>
                  <p class="tooltipValue">{{mytooltipData.location}}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-1 mb-5 pb-1" *ngIf="tooltipHeight < 200"
            [ngClass]="(tooltipTurn < 250) ? 'chart_tooltip_body-after100' :'chart_tooltip_body100'">
            <div class="d-flex m-auto align-items-center pl-0">
              <div class="chart_tooltip_body_data ml-2">
                <div>
                  <p class="mb-0">KPI</p>
                  <p class="tooltipValue">{{mytooltipData.kpi_name}}</p>
                </div>
                <div>
                  <p class="mb-0">Date</p>
                  <p class="tooltipValue">{{mytooltipData.current_date | date:'MM.dd.yyyy'}}</p>
                </div>
                <div>
                  <p class="mb-0">KPI Value</p>
                  <p class="tooltipValue">{{mytooltipData.kpi_value}}</p>
                </div>
                <div>
                  <p class="mb-0">Control Limits</p>
                  <p class="tooltipValue">{{mytooltipData.lower_control_limit.toFixed(2)}} -
                    {{mytooltipData.upper_control_limit.toFixed(2)}}</p>
                </div>
                <div *ngIf="mytooltipData?.lower_threshold != null && mytooltipData?.upper_threshold != null">
                  <p class="mb-0">Threshold</p>
                  <p class="tooltipValue">{{mytooltipData.lower_threshold}} - {{mytooltipData.upper_threshold}}</p>
                </div>
                <div>
                  <p class="mb-0">Location</p>
                  <p class="tooltipValue" [style.visibility]="mytooltipData.location ? 'visible' : 'hidden'">
                    {{mytooltipData.location}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </main>
</div>